export enum paceStatusIcon {
    "Completed" = "paceIconColored",
    "Incomplete" = "paceIconGrayedOut",
    "Not Sharing" = "paceIconNotShared",
    "Unknown" = "paceIconNotShared",
}
